import React from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const UsersReportsTable = () => {
  const { usersReports, loading } = useSelector(
    (state) => state.usersReportsReducer
  );

  const columns = [
    {
      title: "Отчет",
      dataIndex: "reportId",
      key: "reportId",
      rowKey: "reportId",
      width: "5%",
      align: "center",
      sorter: (a, b) => a.reportId - b.reportId,
      render: (text) => (
        <span className="users-reports-table-text">{text}</span>
      ),
    },
    {
      title: "Дата на отчета",
      dataIndex: "reportDate",
      key: "reportDate",
      rowKey: "reportDate",
      width: "10%",
      align: "center",
      sorter: (a, b) => dayjs(b.reportDate) - dayjs(a.reportDate),
      render: (text) => (
        <span className="users-reports-table-text">{text}</span>
      ),
    },
    {
      title: "Отчет на оператор",
      dataIndex: "waiterName",
      key: "waiterName",
      rowKey: "waiterName",
      width: "10%",
      align: "center",
      filters: [
        ...Array.from(
          new Set(usersReports.map((report) => report.waiterName))
        ).map((uniqueName) => ({
          text: uniqueName,
          value: uniqueName,
        })),
      ],
      onFilter: (value, record) => record.waiterName.indexOf(value) === 0,
      render: (text) => (
        <span className="users-reports-table-text">{text}</span>
      ),
    },
    {
      title: "Сума за обслужване",
      dataIndex: "serviceSum",
      key: "serviceSum",
      rowKey: "serviceSum",
      width: "5%",
      align: "center",
      sorter: (a, b) => a.serviceSum - b.serviceSum,
      render: (text) => (
        <span className="users-reports-table-text">{text.toFixed(2)}</span>
      ),
    },
    {
      title: "Бакшиш",
      dataIndex: "tip",
      key: "tip",
      rowKey: "tip",
      width: "5%",
      align: "center",
      sorter: (a, b) => a.tip - b.tip,
      render: (text) => (
        <span className="users-reports-table-text">{text.toFixed(2)}</span>
      ),
    },
    {
      title: "Сума",
      dataIndex: "totalSum",
      key: "totalSum",
      rowKey: "totalSum",
      width: "5%",
      align: "center",
      sorter: (a, b) => a.totalSum - b.totalSum,
      render: (text) => (
        <span className="users-reports-table-text">{text.toFixed(2)}</span>
      ),
    },
    {
      title: "Клиенти",
      children: [
        {
          title: "Брой",
          dataIndex: "clientsCount",
          key: "clientsCount",
          rowKey: "clientsCount",
          width: "10%",
          align: "center",
          sorter: (a, b) => a.clientsCount - b.clientsCount,
          render: (text) => (
            <span className="users-reports-table-text">{text}</span>
          ),
        },
        {
          title: "Средна сума",
          dataIndex: "averageSum",
          key: "averageSum",
          rowKey: "averageSum",
          width: "10%",
          align: "center",
          sorter: (a, b) => a.averageSum - b.averageSum,
          render: (text) => (
            <span className="users-reports-table-text">{text.toFixed(2)}</span>
          ),
        },
      ],
    },
    {
      title: "Платено",
      children: [
        {
          title: "В брой",
          dataIndex: "inCashSum",
          key: "inCashSum",
          rowKey: "inCashSum",
          width: "10%",
          align: "center",
          sorter: (a, b) => a.inCashSum - b.inCashSum,
          render: (text) => (
            <span className="users-reports-table-text">{text.toFixed(2)}</span>
          ),
        },
        {
          title: "По сметка",
          dataIndex: "bankAccountSum",
          key: "bankAccountSum",
          rowKey: "bankAccountSum",
          width: "10%",
          align: "center",
          sorter: (a, b) => a.bankAccountSum - b.bankAccountSum,
          render: (text) => (
            <span className="users-reports-table-text">{text.toFixed(2)}</span>
          ),
        },
        {
          title: "С карта",
          dataIndex: "viaCardSum",
          key: "viaCardSum",
          rowKey: "viaCardSum",
          width: "10%",
          align: "center",
          sorter: (a, b) => a.viaCardSum - b.viaCardSum,
          render: (text) => (
            <span className="users-reports-table-text">{text.toFixed(2)}</span>
          ),
        },
        {
          title: "Др. плащ.",
          dataIndex: "otherPaymentSum",
          key: "otherPaymentSum",
          rowKey: "otherPaymentSum",
          width: "10%",
          align: "center",
          sorter: (a, b) => a.otherPaymentSum - b.otherPaymentSum,
          render: (text) => (
            <span className="users-reports-table-text">{text.toFixed(2)}</span>
          ),
        },
      ],
    },
  ];

  return (
    <div className="users-reports-table-container">
      <Table
        columns={columns}
        dataSource={usersReports}
        rowKey="reportId"
        loading={loading}
      />
    </div>
  );
};

export default UsersReportsTable;
